import styled, { css } from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 0 15px;
  };
`

export const Info = styled.p`
  margin: ${props => props.halfWidth ? '0' : '20px 0 0'};
  color: ${colors.darkPurple};
`

export const Link = styled.a`
  margin: 20px 0 0;
  color: ${colors.blue};
  font-weight: 600;
  cursor: pointer;

  :last-child {
    margin-bottom: 40px;
  }
`
